import { render, staticRenderFns } from "./InstrumentSidebar.vue?vue&type=template&id=5ce17e4a&scoped=true&"
import script from "./InstrumentSidebar.vue?vue&type=script&lang=ts&"
export * from "./InstrumentSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./InstrumentSidebar.vue?vue&type=style&index=0&id=5ce17e4a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce17e4a",
  null
  
)

export default component.exports